import { vehicles } from './Queries'

export const Vehicle = {
  vehicles,
}
